import { Helmet } from 'react-helmet'

export default function AiReceptionistDemoScript() {
  return (
    <>
      <Helmet>
        <script src="https://voicebot-ai.itrust.io/embed.js" id="embed-script"></script>
      </Helmet>
    </>
  )
}
